<template>
  <SeoPage page-key="webAgencyMendrisio" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'WebAgencyMendrisioPage'
})
</script>

